import { createApp } from 'vue';
import { createRouter, createWebHashHistory } from 'vue-router';

import SetupRoot from './setupRoot.vue';
import vuetify from './vuetify';

const step1 = () => import('./components/step1.vue');
const step2 = () => import('./components/step2.vue');
const step3 = () => import('./components/step3.vue');
const step4 = () => import('./components/step4.vue');
const done = () => import('./components/done.vue');

const router = createRouter({
	history: createWebHashHistory(),
	routes: [
		{ path: '/', component: step1 },
		{ path: '/step1', component: step1 },
		{ path: '/step2', component: step2 },
		{ path: '/step3', component: step3 },
		{ path: '/step4', component: step4 },
		{ path: '/step5', component: done },
	],
});

const el = document.getElementById('veva-setup');

if (el) {
	createApp(SetupRoot).use(router).use(vuetify).mount(el);
}
